import { Component, OnInit } from '@angular/core';
import { Title, DomSanitizer } from '@angular/platform-browser';
import { Post } from '../post';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { BlogService } from '../blog.service';

@Component({
  selector: 'app-blogdetails',
  templateUrl: './blogdetails.component.html',
  styleUrls: ['./blogdetails.component.css']
})
export class BlogdetailsComponent implements OnInit {
  post: Post;
  public constructor(
    private sanitizer: DomSanitizer,
    private titleService: Title,
    private route: ActivatedRoute,
    private location: Location,
    private blogService: BlogService) { }

    getPost():void{
      const id = +this.route.snapshot.paramMap.get('id');
      this.blogService.getPost(id)
      .subscribe(post => this.post = post)
    }
    goBack(): void {
      this.location.back();
    }
    
  
  ngOnInit() {
    this.getPost();
    this.titleService.setTitle(`${this.post.title} | Housni Issouffa`);
    this.sanitizer.bypassSecurityTrustHtml(this.post.content);
  }

}
